import { Routes } from "@angular/router";
import { HomeComponent } from "./home.component";
import { PublicGuard } from "./services/guards/public.guard";
import { LoginPageComponent } from "./modules/login/login.page";
import { DashboardPageComponent } from "./modules/dashboard/dashboard.page";
import { PrivateGuard } from "./services/guards/private.guard";
import { IconViewerComponent } from "./services/icon.viewer";
import { AccountsComponent } from "./modules/accounts/accounts.component";
import { eventsRouting } from "./app.events.routing";
import { EventPrivateGuard } from "./services/guards/event.private.guard";
import { HomeBudgetComponent } from "./modules/budget/home-budget.component";
import { traceNames } from "./services/performance.tracking.data";
import { AccountBudgetSummaryComponent } from "./modules/budget/account-budget-summary.component";
import { AccountBudgetQuotesComponent } from "./modules/budget/account-budget-quotes.component";
import { BudgetsTableComponent } from "./modules/budget/budgets-table.component";
import { HomeBudgetLineItemsComponent } from "./modules/budget/home-budget-line-items.component";
import { EventListsComponent } from "./components/events/event-lists.component";
import { ClipboardComponent } from "./components/home/clipboard";
import { AllTasksComponent } from "./components/home/all-tasks.component";

export const routes: Routes = [
  {path: '', component: LoginPageComponent, data: {is_create_user: false}, canActivate: [PublicGuard]},
  { path: 'auth', component: LoginPageComponent, data: {is_create_user: true}, canActivate: [PublicGuard] },
  { path: 'sign-up', component: LoginPageComponent, data: {is_create_user: true}, canActivate: [PublicGuard] },
  { path: 'login', component: LoginPageComponent, data: {is_create_user: false}, canActivate: [PublicGuard] },
  { path: 'verified', component: LoginPageComponent, data: {is_verified: true, is_create_user: false, is_reset_password: false} },
  { path: 'sign-in', component: LoginPageComponent, data: {is_create_user: false}, canActivate: [PublicGuard] },
  { path: 'reset-password', component: LoginPageComponent, data: {is_reset_password: true}},
  { path: 'icons', component: IconViewerComponent, canActivate: [PrivateGuard]},
  { path: 'home/:id', component: DashboardPageComponent, canActivate: [PrivateGuard]},
  { path: 'home', redirectTo: 'home/'}, 
  { path: 'budget', component: HomeBudgetComponent, data: { traceName:traceNames.viewHomeBudget }, canActivate: [PrivateGuard],
      children: [ 
        { path: '', redirectTo: 'summary', pathMatch: 'full'},
        { path: 'summary', component: AccountBudgetSummaryComponent },
        { path: 'quotes', component: AccountBudgetQuotesComponent },
        { path: 'table', component: BudgetsTableComponent },
        { path: 'line-items', component: HomeBudgetLineItemsComponent },
      ] 
  },   
  { path: 'event-lists', component: EventListsComponent, data: { traceName:traceNames.viewEventLists }, canActivate: [PrivateGuard] },
  { path: 'clipboard', component: ClipboardComponent, data: { traceName:traceNames.viewClipboard }, canActivate: [PrivateGuard] },
  { path: 'tasks', component: AllTasksComponent, data: { traceName:traceNames.viewAllTasks }, canActivate: [PrivateGuard] },

  { path: 'event',  children: eventsRouting }, //, canActivateChild: [EventPrivateGuard]
  { path: 'accounts', component: AccountsComponent, canActivate: [PrivateGuard] },
  { path: 'account/:accountId', component: AccountsComponent, canActivate: [PrivateGuard] },

]